
import {
  AllergiesAccordian,
  ContactInformationAccordian,
  EmergencyContactAccordion,
  FamilyHistoryAccordian,
  HeightAndWeightAccordian,
  MedicationAccordian,
  PatientDiagnosisAccordion
} from '@uplift/ui-v2';
import React from 'react';
import { VideoCallDrawerContentContainer, VideoCallDrawerContentContainerProps } from '../Layout';
import { BaseQueryOpts, useUserAddressQuery, useUserContactsQuery, useUserEmergencyContactQuery, useUserQuery } from '@uplift/queries';
import { ProviderMedicalRole, UserStatus } from '@uplift/types';

export type ProfileDrawerProps = {
  patientId: string;
  medicalRole: ProviderMedicalRole | null;
} & Pick<VideoCallDrawerContentContainerProps, 'onClose'>;

const opts: BaseQueryOpts = { suspense: true };

export const ProfileDrawer: React.VFC<ProfileDrawerProps> = (props) => {
  const { data: user } = useUserQuery(props.patientId, opts);
  const options = { ...opts, enabled: (user?.status === UserStatus.regular && !!props.patientId) };

  const { data: contactsData = [] } = useUserContactsQuery(props.patientId, options);
  const { data: emergencyContact } = useUserEmergencyContactQuery(props.patientId, options);
  const { data: addressData } = useUserAddressQuery(props.patientId, options);


  const contacts = contactsData.filter(c => c.value) ?? [];
  const isEditable = props.medicalRole === ProviderMedicalRole.psychiatrist;

  return (
    <VideoCallDrawerContentContainer onClose={props.onClose} title="Profile">

      <PatientDiagnosisAccordion patientId={props.patientId} />
      <MedicationAccordian patientId={props.patientId} editable={isEditable} inlineForm />
      <AllergiesAccordian patientId={props.patientId} editable={isEditable} inlineForm />
      <HeightAndWeightAccordian patientId={props.patientId} editable={isEditable} inlineForm />
      <FamilyHistoryAccordian patientId={props.patientId} />
      <ContactInformationAccordian
        contacts={contacts}
        address={addressData.address}
        state={addressData.state}
      />
      <EmergencyContactAccordion
        emergencyContact={emergencyContact}
        canAdd
        inlineForm
        patientId={props.patientId}
      />

    </VideoCallDrawerContentContainer>
  );
};
